import { render, staticRenderFns } from "./ServiceGroupForm.vue?vue&type=template&id=487b16a2"
import script from "./ServiceGroupForm.vue?vue&type=script&lang=js"
export * from "./ServiceGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports